import { times } from 'lodash'
import { subMonths, eachDay, startOfMonth, endOfMonth, format } from 'date-fns'
import { padZero, range } from '@/utils/number'

export function validate(validator, params) {
  const { error } = validator.validate(params, { allowUnknown: true })
  return error ? [400, { status: 0, message: error.details.map(({ message }) => message) }] : null
}

export function number(length) {
  return times(length, i => i % 10).join('')
}

export function ascii(length) {
  return times(length, i => String.fromCharCode(97 + (i % 5))).join('')
}

export function zenkaku(length) {
  return times(length, i => String.fromCharCode(0xfee0 + (i % 10))).join('')
}

export function kana(length) {
  return times(length, i => String.fromCharCode(0x3041 + (i % 10))).join('')
}

/**
 * アプリへの postMessage ハンドラをモックします.
 *
 * @param {...string} methods モックするメソッド名
 */
export function nativeMock(...methods) {
  methods.forEach(method => {
    const set = require('lodash/set')
    const key = `webkit.messageHandlers.${method}.postMessage`
    set(window, key, (...args) => console.log('CALL', key, ...args))
  })
}

export const toZenkaku = ((String, fromCharCode) => {
  function zen(string) {
    return String(string)
      .replace(/\u0020/g, '\u3000')
      .replace(/\u0022/g, '\u201D')
      .replace(/\u0027/g, '\u2019')
      .replace(/\u005C/g, '\uFFE5')
      .replace(/[!#-&(),-9\u003C-?A-[\u005D_a-{}~]/g, alphaNum)
  }
  function alphaNum(token) {
    return fromCharCode(token.charCodeAt(0) + 65248)
  }
  return zen
})(String, String.fromCharCode)

/**
 * チャートで使用するラベルを作成する
 * @param {Date} current データ作成起点となる時刻
 */
export const createChartLabels = (current = new Date(2020, 9, 1)) => ({
  hours: range(25, 6).map(hour => `${padZero(hour)}:00`),
  days: eachDay(startOfMonth(current), endOfMonth(current)).map(date => format(date, 'D日')),
  weeks: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
  months: range(24)
    .reverse()
    .map(key => format(subMonths(current, key), 'YYYY/MM')),
})

/**
 * チャートのデータを作成する
 * @param {object} infos { name: シリーズ名, seed: 基礎値, swing: 振れ幅 }
 * @param {string[]} hAxisAry 横軸の配列
 */
export const createChartData = (() => {
  /**
   * シリーズを作成する
   * @param {object} param0 { size: 横軸数, seed: 基礎値, swing: 振れ幅 }
   */
  const createSeries = ({ size, seed, swing }) =>
    range(size).map(() => {
      seed += swing
      return seed
    })

  return (infos, hAxisAry) => {
    const series = infos.map(({ name: _, ...rest }) => createSeries({ size: hAxisAry.length, ...rest }))
    return [
      ['', ...infos.map(({ name }) => name)],
      ...hAxisAry.map((hAxis, idx) => [hAxis, ...series.map(serie => serie[idx])]),
    ]
  }
})()
